module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/video-collage/1.png?8033b460973cacab2fb48c27098ffe54";